<div class="product-detail-modal">
    <!-- Header Section -->
    <div class="modal-header">
        <div class="header-content">
            <div class="product-info">
                <div class="product-image">
                    <img src="../../../assets/images/product_sm.png" alt="product" class="product-img">
                </div>
                <div class="product-details">
                    <h1 class="product-title">{{ implantDetails?.product_name }}</h1>
                    <p class="product-subtitle">Last updated on {{ implantDetails?.last_updated_at }}</p>
                </div>
            </div>
            <div class="header-actions">
                <div class="status-badge" [ngClass]="'status-' + implantDetails?.status">
                    {{ implantDetails?.status?.charAt(0).toUpperCase() + implantDetails?.status?.slice(1) }}
                </div>
                <div class="action-buttons">
                    <button *ngIf="implantDetails?.status === 'active'" 
                            class="btn-edit" 
                            (click)="openEditDialog(dialogData.storeId, dialogData.productStockId)"
                            title="Edit Implant">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.3333 2L14 4.66667L5.33333 13.3333H2.66667V10.6667L11.3333 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                    <button class="btn-close" (click)="onClose()" title="Close">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Content Section -->
    <div class="modal-content">
        <div class="content-grid">
            <!-- Product Information Section -->
            <div class="section-wrapper product-info-wrapper">
                <div class="product-info-section">
                    <div class="section-header">
                        <h3 class="section-title">Product Information</h3>
                        <div class="section-divider"></div>
                    </div>
                    <div class="info-grid">
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 3H14C14.5523 3 15 3.44772 15 4V12C15 12.5523 14.5523 13 14 13H2C1.44772 13 1 12.5523 1 12V4C1 3.44772 1.44772 3 2 3Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M5 7H11M5 9H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                            <div class="info-content">
                            <label class="info-label">Store</label>
                            <span class="info-value">{{ implantDetails?.store_name }}</span>
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 1L10.5 5.5L15.5 6L12 9.5L13 14.5L8 12L3 14.5L4 9.5L0.5 6L5.5 5.5L8 1Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div class="info-content">
                            <label class="info-label">Product Code</label>
                            <span class="info-value">{{ implantDetails?.product_code }}</span>
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 4H14M5.33333 4V2.66667C5.33333 2.31305 5.47381 1.97391 5.72386 1.72386C5.97391 1.47381 6.31305 1.33333 6.66667 1.33333H9.33333C9.68696 1.33333 10.0261 1.47381 10.2761 1.72386C10.5262 1.97391 10.6667 2.31305 10.6667 2.66667V4M12.6667 4V13.3333C12.6667 13.687 12.5262 14.0261 12.2761 14.2761C12.0261 14.5262 11.687 14.6667 11.3333 14.6667H4.66667C4.31305 14.6667 3.97391 14.5262 3.72386 14.2761C3.47381 14.0261 3.33333 13.687 3.33333 13.3333V4H12.6667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div class="info-content">
                            <label class="info-label">Batch Number</label>
                            <span class="info-value">{{ implantDetails?.batch_no || 'N/A' }}</span>
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2H4C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M6 6H10M6 8H10M6 10H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                            <div class="info-content">
                            <label class="info-label">Expiry Date</label>
                            <span class="info-value">{{ implantDetails?.expiry_date }}</span>
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 1V3M8 13V15M3 8H1M15 8H13M4.22 4.22L2.81 2.81M11.78 11.78L13.19 13.19M4.22 11.78L2.81 13.19M11.78 4.22L13.19 2.81" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div class="info-content">
                            <label class="info-label">RFID</label>
                            <span class="info-value">{{ implantDetails?.rfid || 'N/A' }}</span>
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 3H14C14.5523 3 15 3.44772 15 4V12C15 12.5523 14.5523 13 14 13H2C1.44772 13 1 12.5523 1 12V4C1 3.44772 1.44772 3 2 3Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M5 7H11M5 9H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                            <div class="info-content">
                            <label class="info-label">Product Category</label>
                            <span class="info-value">{{ implantDetails?.product_category }}</span>
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 3H14C14.5523 3 15 3.44772 15 4V12C15 12.5523 14.5523 13 14 13H2C1.44772 13 1 12.5523 1 12V4C1 3.44772 1.44772 3 2 3Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M5 7H11M5 9H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                            <div class="info-content">
                            <label class="info-label">Cabinet</label>
                            <span class="info-value">
                                <a *ngIf="implantDetails?.cabinet_name" 
                                   (click)="redirectToCabinet(implantDetails?.cabinet_id)" 
                                   class="cabinet-link">{{ implantDetails?.cabinet_name }}</a>
                                <span *ngIf="!implantDetails?.cabinet_name">At Store</span>
                            </span>
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 1V3M8 13V15M3 8H1M15 8H13M4.22 4.22L2.81 2.81M11.78 11.78L13.19 13.19M4.22 11.78L2.81 13.19M11.78 4.22L13.19 2.81" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div class="info-content">
                            <label class="info-label">Device ID</label>
                            <span class="info-value">{{ implantDetails?.device_id || 'N/A' }}</span>
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 1V3M8 13V15M3 8H1M15 8H13M4.22 4.22L2.81 2.81M11.78 11.78L13.19 13.19M4.22 11.78L2.81 13.19M11.78 4.22L13.19 2.81" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div class="info-content">
                            <label class="info-label">Body Type</label>
                            <span class="info-value">{{ implantDetails?.body_type }}</span>
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 1V3M8 13V15M3 8H1M15 8H13M4.22 4.22L2.81 2.81M11.78 11.78L13.19 13.19M4.22 11.78L2.81 13.19M11.78 4.22L13.19 2.81" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div class="info-content">
                            <label class="info-label">Implant Type</label>
                            <span class="info-value">{{ implantDetails?.implant_type }}</span>
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 1V3M8 13V15M3 8H1M15 8H13M4.22 4.22L2.81 2.81M11.78 11.78L13.19 13.19M4.22 11.78L2.81 13.19M11.78 4.22L13.19 2.81" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div class="info-content">
                            <label class="info-label">Rate</label>
                            <span class="info-value price">€{{ implantDetails?.rate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Activity Timeline Section -->
            <div class="section-wrapper timeline-wrapper-section">
                <div class="timeline-section">
                    <div class="section-header">
                    <h3 class="section-title">Activity Timeline</h3>
                        <div class="section-divider"></div>
                    </div>
                    <div class="timeline-container">
                        <div #timelineWrapper class="timeline-wrapper">
                            <div class="timeline-item" *ngFor="let timeline of implantDetails.timeline; index as i">
                                <div class="timeline-dot" [ngClass]="i === 0 ? 'active' : ''">
                                    <div class="dot"></div>
                                    <div *ngIf="i !== implantDetails?.timeline.length - 1" class="timeline-line"></div>
                                </div>
                                <div class="timeline-content">
                                    <div class="timeline-header">
                                        <h4 class="timeline-title">{{ timeline?.title }}</h4>
                                        <span class="timeline-action" 
                                              *ngIf="timeline?.action && timeline?.action !== 'received'"
                                              [ngClass]="'action-' + timeline?.action">
                                            {{ timeline?.action === "in" || timeline?.action === "out" ? 'Stock ' : '' }}{{ timeline?.action }}
                                        </span>
                                    </div>
                                    <p *ngIf="timeline.store_name && timeline?.action !== 'received'" 
                                       class="timeline-location">{{ timeline.store_name }}</p>
                                    <p class="timeline-timestamp">{{ timeline?.timestamp }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

